import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-900 text-background-100 mt-16">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2 max-w-md">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-leaf-line text-xl" />
              </span>
              <span className="font-heading font-bold text-xl text-background-50">香草视频</span>
            </div>
            <p className="text-sm leading-relaxed text-background-200/80">
              香草在线观看免费播放电视剧，专注为追剧爱好者汇总最新高清电视剧资源，覆盖都市、古装、悬疑、爱情等多种类型，支持在线浏览与收藏关注，让追剧更轻松。
            </p>
            <p className="mt-4 text-sm text-background-200/80 flex items-center gap-2">
              <i className="ri-mail-line" />
              联系邮箱：contact@vanilla-tv-demo.com
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide">快速导航</h4>
            <ul className="space-y-2.5 text-sm text-background-200/80">
              <li><Link to="/" className="hover:text-accent-300 transition-colors">首页</Link></li>
              <li><Link to="/category" className="hover:text-accent-300 transition-colors">电视剧分类</Link></li>
              <li><Link to="/search" className="hover:text-accent-300 transition-colors">搜索电视剧</Link></li>
              <li><Link to="/about" className="hover:text-accent-300 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide">热门类型</h4>
            <ul className="space-y-2.5 text-sm text-background-200/80">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.key}>
                  <Link to={`/category/${encodeURIComponent(cat.key)}`} className="hover:text-accent-300 transition-colors">
                    {cat.label}电视剧
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-100/20 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-background-200/70">
          <p>© {year} 香草视频 · 本站内容均为演示示例数据</p>
          <p>友情链接：香草影视资源站 · 高清追剧社区 · 剧集资料库</p>
        </div>
        <p className="mt-4 text-xs leading-relaxed text-background-200/60">
          免责声明：本网站为演示性质的内容平台，所有电视剧名称、简介、演职人员等信息均为虚拟示例，播放功能仅作界面演示，不提供任何真实视频资源，也不存储任何影视内容。
        </p>
      </div>
    </footer>
  );
}